export default __webpack_public_path__ + "media/images/uploadOrange-c9df2dd1.svg";